// extracted by mini-css-extract-plugin
export default {"shadowed":"Home_shadowed__izFwS","typing":"Home_typing__LJAJK","hand":"Home_hand__xy1kw","wave":"Home_wave__beMRz","avatar":"Home_avatar__D+L94"};